export const generateAdCustomParamsString = (
  obj: Record<string, unknown>
): string => {
  const entries = Object.entries(obj)
    .filter(([key, value]) => value !== null && typeof value !== 'undefined')
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return [key, value.map((item) => encodeURIComponent(item)).join(',')];
      }

      return [key, encodeURIComponent(value as string)];
    });

  return entries.map(([key, value]) => [key, value].join('=')).join('&');
};

export const prepareAdTagUrl = (options?: {
  useGamPadLivePath?: boolean;
  output?: string;
  adTagUrl?: string | null;
  adUnitCode?: string;
  adSize?: string;
  adCustomParams?: string;
  adDescriptionUrl?: string;
}) => {
  const {
    useGamPadLivePath = true,
    output = 'vast',
    adTagUrl,
    adUnitCode,
    adSize = '640x360',
    adCustomParams,
    adDescriptionUrl,
  } = options ?? {};

  if (adTagUrl) return adTagUrl;

  if (!adUnitCode) return '';

  // reference: https://support.google.com/admanager/answer/10678356?hl=en
  return [
    'https://pubads.g.doubleclick.net/gampad',
    ...(useGamPadLivePath ? ['/live'] : []),
    '/ads?',
    [
      `sz=${adSize}`,
      `iu=${adUnitCode}`,
      `impl=s`,
      `gdfp_req=1`,
      `env=vp`,
      `output=${output}`,
      `unviewed_position_start=1`,
      `url=[referrer_url]`, // IMA SDK will help to fill in this macro
      `description_url=${
        adDescriptionUrl
          ? encodeURIComponent(adDescriptionUrl)
          : '[description_url'
      }`,
      `correlator=[timestamp]`, // IMA SDK will help to fill in this macro
      // encodeURIComponent will encode `,` `=` `&` required in the doc https://support.google.com/admanager/answer/1080597
      `cust_params=${adCustomParams ? encodeURIComponent(adCustomParams) : ''}`,
      `plcmt=1`, // https://support.google.com/admanager/answer/10661571?hl=en
    ].join('&'),
  ].join('');
};
